import React from 'react';
import { BookOpen, GitBranch, Download, Loader2 } from 'lucide-react';
import type { Book } from '../../../../shared/types/index.js';

interface VerificationFooterActionsProps {
  book: Book | null;
  isOwnerOrAdmin: boolean;
  isDownloadingCert: boolean;
  onOpenFullDetail?: (book: Book) => void;
  onOpenEditionTree?: (book: Book) => void;
  onDownloadPdf: () => void;
  onClose: () => void;
}

export const VerificationFooterActions: React.FC<VerificationFooterActionsProps> = ({
  book,
  isOwnerOrAdmin,
  isDownloadingCert,
  onOpenFullDetail,
  onOpenEditionTree,
  onDownloadPdf,
  onClose,
}) => {
  return (
    <div className="p-4 border-t border-slate-200 bg-white flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-2.5">
      <div className="flex items-center gap-2">
        {book && onOpenFullDetail && (
          <button
            type="button"
            onClick={() => onOpenFullDetail(book)}
            className="px-3 py-2 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 text-xs font-semibold flex items-center gap-1.5 transition cursor-pointer"
          >
            <BookOpen className="w-3.5 h-3.5" />
            <span>Buka Detail Lengkap</span>
          </button>
        )}

        {book && onOpenEditionTree && (
          <button
            type="button"
            onClick={() => onOpenEditionTree(book)}
            className="px-3 py-2 rounded-xl bg-indigo-50 hover:bg-indigo-100 text-indigo-700 border border-indigo-200 text-xs font-semibold flex items-center gap-1.5 transition cursor-pointer"
          >
            <GitBranch className="w-3.5 h-3.5" />
            <span>Silsilah Edisi (Tree)</span>
          </button>
        )}
      </div>

      <div className="flex items-center gap-2">
        {book && isOwnerOrAdmin && book.status !== 'diajukan' && (
          <button
            type="button"
            onClick={onDownloadPdf}
            disabled={isDownloadingCert}
            className="px-3.5 py-2 rounded-xl bg-amber-500 hover:bg-amber-600 text-slate-950 text-xs font-bold flex items-center gap-1.5 transition shadow-xs cursor-pointer disabled:opacity-50"
          >
            {isDownloadingCert ? (
              <Loader2 className="w-3.5 h-3.5 animate-spin" />
            ) : (
              <Download className="w-3.5 h-3.5" />
            )}
            <span>Unduh E-Sertifikat PDF</span>
          </button>
        )}

        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-xs font-semibold transition cursor-pointer"
        >
          Tutup
        </button>
      </div>
    </div>
  );
};
